"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsProvider = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const PageLoaderComponent_1 = require("src/configeek_assets/src/components/common/widget/PageLoaderComponent");
const ProjectsProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    (0, react_1.useEffect)(() => {
        if (isMounted()) {
            projectsDataContext.fetchProjects();
        }
    }, [isMounted, projectsDataContext.fetchProjects]);
    if (!projectsDataContext.projectsCumulativeInfo.status.loaded) {
        return React.createElement(PageLoaderComponent_1.PageLoaderComponent, null);
        // return <PageLoaderComponent>ProjectsProvider: loading</PageLoaderComponent>
    }
    return React.createElement(React.Fragment, null, props.children);
};
exports.ProjectsProvider = ProjectsProvider;
